/**
 * 预览修订信息提示框
 */
"use strict";
angular.module("previewReviseInfoModule", []).
directive("previewReviseInfo", ["$q", function($q) {
    return {
        restrict: "A",
        replace: false,
        scope: true,
        link: function(scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                   flag:true
               };
                for(var i in scope.item){
                    if(scope.item[i]==='待修订'){
                        scope.status.flag=false;
                    }
                }
                if(scope.status.flag) return;
                watcher().then(function() {
                    initElement();
                    initMouseEnter();
                    initMouseLeave();
                    initDestroy();
                });
            }
            /**
             * [initDestroy description] 初始化销毁事件
             * @return {[type]} [description]
             */
            function initDestroy() {
                scope.$on("$destroy", function() {
                    if (angular.isDefined(scope.status.$template)) {
                        scope.status.$template.remove();
                    }
                });
            }
            /**
             * [initElement description] 初始化容器样式
             * @return {[type]} [description]
             */
            function initElement() {
                $elem.css({ position: "relative" });
            }
            /**
             * [initMouseEnter description] 初始化鼠标移入
             * @return {[type]} [description]
             */
            function initMouseEnter() {
                $elem.bind("mouseenter", function() {
                    scope.status.$template = $(["<div class='previewRevise'>",
                        "<div></div>",
                        "<div>",
                        "<p>指定人：" + scope.item.APPOINTUSER + "</p>",
                        "<p>指定时间：" + scope.item.MODIFYTIME + "</p>",
                        "<p>修订人：" + scope.item.MODIFYUSER + "</p>",
                        "</div>",
                        "<div class='arrow'> </div>",
                        "<div>"
                    ].join(""));
                    $("body").append(scope.status.$template);
                    CorrectDirection();
                });
            }
            /**
             * [initDirection description] 修正tip显示的方向 当向下显示空间不足时，自动向上显示
             * @return {[type]} [description]
             */
            function CorrectDirection() {
                var bodyHeight = $("body").height();
                var parentHeight = $elem[0].offsetHeight;
                var parentTop = $elem.offset().top;
                var parentLeft = $elem.offset().left;
                var templateTop = scope.status.$template.offset().top;
                if (!isNaN($attrs["customMaxWidth"])) { //自定义摘要宽度
                    scope.status.$template.css({ maxWidth: Number($attrs["customMaxWidth"]) });
                }
                var templateHeight = scope.status.$template[0].offsetHeight;
                //if ((templateTop + templateHeight) > bodyHeight) {
                scope.status.$template.css({ top: parentTop - templateHeight, left: parentLeft });
                scope.status.$template.find(".arrow").css({
                    transform: "rotate(180deg)",
                    top: templateHeight
                });
                if (templateHeight > parentTop - 60) {
                    //上面放不下就放下面
                    scope.status.$template.css({ top: parentTop + parentHeight + 6, left: parentLeft });
                    if (templateHeight > bodyHeight - parentHeight - parentTop) { //下面也放不下就加宽
                        if (!isNaN($attrs["customMaxWidth"])) { //自定义摘要宽度
                            scope.status.$template.css({ maxWidth: Number($attrs["customMaxWidth"]) });
                        }
                    }
                    scope.status.$template.find(".arrow").css({
                        transform: "rotate(0deg)",
                        top: -6
                    });
                }
                /*} else {
                    var $arrow = scope.status.$template.find(".arrow");
                    var arrowHeight = $arrow[0].offsetHeight;
                    $arrow.css({ top: -arrowHeight });
                }*/

            }
            /**
             * [initMouseLeave description] 初始化鼠标移出
             * @return {[type]} [description]
             */
            function initMouseLeave() {
                $elem.bind("mouseleave", function() {
                    $("body").find(".previewRevise").remove();
                });
            }
            /**
             * [watcher description] 监听信息是否已经获取到
             * @return {[type]} [description]
             */
            function watcher() {
                var deffer = $q.defer();
                scope.status.watcher = scope.$watch("item.APPOINTUSER", function(newV, oldV) {
                    if (!newV) {
                        deffer.resolve();
                        scope.status.watcher();
                    }
                });
                return deffer.promise;
            }
        }
    };
}]);